import { Loading } from "components/Parts/Atoms/Loading";
import { MainWrapper } from "components/Parts/Atoms/MainWrapper";
import { ContentMain } from "components/Parts/Organisms/ContentMain";
import { HeaderBar } from "components/Parts/Organisms/HeaderBar";
import React, { Suspense } from "react";
import { StickyNoteInputDialog } from "../StickyNoteInputDialog";
import { StickyNoteInputMode } from "../StickyNoteInputDialog/enums";
import { useCheckStickyNotesHooks } from "./hooks";
import { ConditionSelector } from "./subComponents/ConditionSelector";
import { OpenLevelSelectDialog } from "./subComponents/OpenLevelSelectDialog";
import { StickyNotesList } from "./subComponents/StickyNoteList";

export const CheckStickyNotesPage = React.memo(() => {
  const {
    mainContext,

    condition,
    openOpenLevelSelectDialog,

    stickyNotes,

    clickedStickyNote,
    inputMode,

    busy,

    onOpenLevelsClick,
    onOpenLevelSelectDialogClose,
    onOpenLevelSelectDialogOkClick,

    onSearchClick,

    onStickyNoteClick,
    onInputDialogOkButtonClick,
    onInputClose
  } = useCheckStickyNotesHooks();

  return (
    <ContentMain>
      <HeaderBar
        authStatus={mainContext.authStatus}
        authUser={mainContext.authUser}
        user={mainContext.user}
        company={mainContext.company}
        userInfo={mainContext.userInfo}
        groups={mainContext.groups}
      />
      <Suspense fallback={Loading}>
        <MainWrapper>
          <ConditionSelector
            openLevels={condition.openLevels}
            company={condition.company}
            onOpenLevelsClick={onOpenLevelsClick}
            onSearchClick={onSearchClick}
          />
          <StickyNotesList
            stickyNotes={stickyNotes}
            busy={busy}
            disabled={busy}
            onStickyNoteClick={onStickyNoteClick}
          />
        </MainWrapper>
        <OpenLevelSelectDialog
          open={openOpenLevelSelectDialog}
          openLevels={condition.openLevels}
          onClose={onOpenLevelSelectDialogClose}
          onCloseClick={onOpenLevelSelectDialogClose}
          onOkClick={onOpenLevelSelectDialogOkClick}
        />
        <StickyNoteInputDialog
          open={!!clickedStickyNote && !!inputMode}
          okButtonCaption={
            inputMode === StickyNoteInputMode.Update ? "更新" : "削除"
          }
          busy={busy}
          mode={inputMode}
          initialLatitude={clickedStickyNote?.latitude ?? null}
          initialLongitude={clickedStickyNote?.longitude ?? null}
          stickyNoteId={clickedStickyNote?.id ?? null}
          errorMessage={""}
          onClose={onInputClose}
          onOkButtonClick={onInputDialogOkButtonClick}
        />
      </Suspense>
    </ContentMain>
  );
});
